import React, {useEffect, useState} from 'react'
import {useField} from 'formik'
import {useTranslation} from 'react-i18next'
import {fetchContractor, fetchContractorsPage} from 'services/ContractorService'
import {CreateContractorDialog} from 'components/Contractors'
import ContractorRole from 'constants/ContractorRole'
import {useErrorHandling} from 'context/errorHandling'
import {fetchContractorPolicies} from 'services/InsurancePolicyService'
import moment from 'moment'
import {CustomWarningMessageText} from 'components/Shared/ErrorMessage'
import {
  ControlledSelectFieldWithInfinityScroll
} from 'components/Shared/ControlledSelectFieldWithInfinityScroll'
import {CONTRACTOR_CREATE, useAuth} from 'context/auth'

export function ContractorSelectField({
                                        label,
                                        fieldName,
                                        className,
                                        disabled,
                                        onChange = () => {
                                        },
                                        onContractorCreated,
                                        role,
                                        defaultFilters,
                                        helperText,
                                        verifyContractorPolicy = false,
                                        creationRequiredRoles = [ContractorRole.CARRIER]
                                      }) {
  const {t} = useTranslation()
  const {handleError} = useErrorHandling()
  const [{value}, , {setValue}] = useField(fieldName)
  const {hasAnyPrivileges} = useAuth()

  const [inactivePolicyWarning, setInactivePolicyWarning] = useState(' ')
  const [createContractorWithName, setCreateContractorWithName] = useState()
  const [carrier, setCarrier] = useState()

  useEffect(() => {
    if (value) {
      fetchContractor(value).then(carrier => {
        setCarrier(carrier)
      })
        .catch(handleError)
    }
  }, [handleError, value])

  const fetchData = (page, rowsPerPage, filters) => {
    if (defaultFilters) {
      for (const [key, value] of Object.entries(defaultFilters)) {
        filters.push({key, value})
      }
    }
    if (role) {
      filters.push({key: 'roles', value: role})
    }
    return fetchContractorsPage(
      {
        page: page,
        rowsPerPage: rowsPerPage,
        sort: [{param: 'usesNumber', order: 'desc'}],
        filters: filters
      })
  }

  const onCreateContractorClick = (name) => {
    setCreateContractorWithName(name)
  }

  useEffect(() => {
    if (verifyContractorPolicy && value) {
      fetchContractorPolicies(value)
        .then(policies => {
          const hasActivePolicy = policies
            .map(policy => policy.endDate)
            .some(date => moment(date).isAfter())
          setInactivePolicyWarning(hasActivePolicy ? ' ' : 'form.validation.inactiveInsurancePolicy')
        })
        .catch(() => setInactivePolicyWarning('form.validation.cannotAccessContractorPolicies'))
    }
  }, [value, handleError, verifyContractorPolicy])

  function closeContractorDialog(newCarrier) {
    if (newCarrier) {
      setCarrier(newCarrier)
      setValue(newCarrier.id)
      onChange(newCarrier.id)
      onContractorCreated && onContractorCreated()
    }
    setCreateContractorWithName(null)
  }

  return <>
    <CreateContractorDialog
      requiredRoles={creationRequiredRoles}
      open={!!createContractorWithName}
      newContractorName={createContractorWithName}
      onClose={closeContractorDialog}/>
    <ControlledSelectFieldWithInfinityScroll
      getOptionLabel={carrier => carrier ? `${carrier.shortName}, ${carrier.nipNumber}` : ''}
      initialOption={carrier ? carrier : null}
      label={t(label)}
      fieldName={fieldName}
      fetchData={fetchData}
      disabled={disabled}
      disableClear
      className={className}
      onChange={onChange}
      searchField={'shortName'}
      addObjectParams={hasAnyPrivileges([CONTRACTOR_CREATE]) && {
        addToken: 'form.add',
        openAddDialog: onCreateContractorClick
      }}
      helperText={helperText}
    />
    {inactivePolicyWarning && <CustomWarningMessageText message={t(inactivePolicyWarning)}/>}
    {/*<CustomWarningMessageText message={helperText}/>*/}
  </>
}
